export default "<app-header *ngIf=\"!isIframe\"></app-header>\r\n<router-outlet></router-outlet>\r\n"